<script>
  import TransactionsList from '../../components/transactions/TransactionsList.svelte'

</script>

<div class="notifications">
  <div class="columns">
    <div class="column">
      <div class="content">
        <TransactionsList />
      </div>
    </div>
  </div>
</div>
